import type { FC } from 'react';
import type { ButtonProps } from 'antd';
import { StyledGooglePlusIcon, StyledGoogleSignInButton } from './GoogleSignInButton.styles';


interface GoogleSignInButtonProps extends ButtonProps {
  text?: string;
}

export const GoogleSignInButton: FC<GoogleSignInButtonProps> = ({
  text = 'Continue with Google',
  size = 'large',
  ...rest
}) => (
  <StyledGoogleSignInButton {...rest} size={size}>
    <StyledGooglePlusIcon />

    <span>
      {text}
    </span>
  </StyledGoogleSignInButton>
);
